import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// dispatch function for tab data for request quarterly payment Display screen
export const quarterlyPaymentObj = (data) => ({
  type: actionTypes.GET_CURRENT_QUARTERLY_PAY_DISPLAY_OBJ,
  screenData: data,
});

// dispatch function for tab data for request quarterly payment Display screen
export const quarterlyPaymentDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_QUARTERLY_PAY_DETAIL_OBJ,
  detailScrData: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgQtrlyPayment = (data) => ({
  type: actionTypes.GET_ERROR_MSG_QUARTERLY_PAYMENT,
  payload: data,
});

// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM,
  payload: data,
});

// get quarterly payment data on Search dispatch function
export const dispatchQuarterlyPaymentData = (data) => ({
  type: actionTypes.GET_QUARTERLY_PAYMENT_DATA,
  payload: data,
});

// To get quarterly payment data on search
export const getQuarterlyPayment = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTERLY_PAYMENT_DATA, value)
    .then((response) => {
      return dispatch(
        dispatchQuarterlyPaymentData(
          // response && response.data && response.data.data
          response.data
        )
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterlyPaymentData([]));
    });
};

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return dispatch(dispatchRebatePrograme(response.data));
    })
    .catch((response) => {
      dispatch(dispatchRebatePrograme([]));
    });
};

// dispatch manufacturer
export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURERS_DATA_LIST,
  manufacturerList: data,
});

// api for get manufacturer list
export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_DATA_LIST, value)
    .then((response) => {
      return dispatch(dispatchManufacturerData(response.data));
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};

//dispatch DRAMS

export const dispatchDRAMS = (data) => ({
  type: actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

//get DRAMS Quarter

export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS([]));
    });
};

//dispatch Earliest Qtr

export const dispatchEarliestDrugQtr = (data) => ({
  type: actionTypes.GET_EARLIEST_QTR_DRUG_VALUE,
  payload: data,
});

//get Earliest Drag Quarter

export const getEarliestDrugQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EARLIEST_QTR_DRUG, value)
    .then((response) => {
      return dispatch(dispatchEarliestDrugQtr(response.data));
    })
    .catch((response) => {
      dispatch(dispatchEarliestDrugQtr([]));
    });
};

//QUarter range dispatch
export const dispatchQuarterRange = (data) => ({
  type: actionTypes.DISPLAY_QUARTER_RANGE,
  payload: data,
});

//quarter range display
export const dispatchQuarterRangeObj = (data) => ({
  type: actionTypes.DISPLAY_QUARTER_OBJ,
  payload: data,
});

//dispatch balance threshold
export const dispatchBalanceThreshold = (data) => ({
  type: actionTypes.GET_BALANCE_THRESHOLD_VALUE,
  payload: data,
});

//get Balance threshold

export const getBalanceThresold = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_BALANCE_THRESHOLD, value)
    .then((response) => {
      return dispatch(
        dispatchBalanceThreshold(
          response?.data?.balanceDueThresholdVO?.rptBalanceDueThreshold
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchBalanceThreshold([]));
    });
};

//Display screen input field

export const dispatchDisplayInputField = (data) => ({
  type: actionTypes.DISPLAY_QUARTERLY_PAYMENT_DETAILS,
  payload: data,
});

//Refresh Tab
export const clearQtrlyPayTab = (payload) => {
  return {
    type: actionTypes.CLEAR_QTRLY_PAY_TAB,
  };
};
